import { Skeleton } from '@mui/material';

function NewCaseSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
      <Skeleton sx={{ bgcolor: '#edf2f7' }} variant='rounded' height={130} />
      <Skeleton sx={{ bgcolor: '#edf2f7' }} variant='rounded' height={50} />
      {Array.from(Array(8).keys()).map((_, i) => (
        <Skeleton key={i} sx={{ bgcolor: '#edf2f7' }} variant='rounded' height={100} />
      ))}
    </div>
  );
}

export default NewCaseSkeleton;
